<template>
  <div class="span-16-lg relative border-left-right-blue" style="height: 100%;">
    
    <div class="relative ind-1 full-span-outer overflow-hidden">
      <div class="scroll-outer" ref="scrollHookOne">
        
        <div class="full-span-inner content-translate" v-bind:class="contentClass">
          <slot></slot>
        </div>

      </div>
    </div>
    
    <span-background v-if="!nobg" full="true"></span-background>

  </div>
</template>

<script>
  import crosshair_background from '../atoms/crosshair_background'
  import span_background from '../atoms/span_background'

  import PerfectScrollbar from 'perfect-scrollbar';

  export default {
    props: ['active', 'nobg'],
    components: {
      'span-background': span_background,
      'crosshair-background': crosshair_background,
      psOne: null
    },
    data () {
      return {
        contentClass: 'content-inactive'
      }
    },
    methods: {
      scrollBarInit () {
        if (window.innerWidth > 1200 && window.innerHeight > 600 && !this.psOne) {
          const containerOne = this.$refs.scrollHookOne
          this.psOne = new PerfectScrollbar(containerOne);
        } else if (this.psOne) {
          this.psOne.destroy()
          this.psOne = null
        }
        window.addEventListener('resize', this.scrollBarInit)
      },
      activeCallback () {
        let int = 800
        if (this.active) {
          setTimeout(() => {
            this.scrollBarInit()
            this.contentClass = ''
          }, int)
          setTimeout(() => {
            if (this.psOne) this.psOne.update()
          }, int + 1000)
        } else {
          setTimeout(() => {
            this.contentClass = 'content-inactive'
          }, int)
        }
      }
    },
    mounted () {
      this.activeCallback()
    },
    watch: {
      active () {
        this.activeCallback()
      }
    }
  }
</script>


<style scoped lang="scss">

  @import '../../styles/variables';

  .full-span-outer {
    position: relative;
    box-sizing: border-box;
    display: flex;
    height: 600px; // 1/2 ratio from 1200px
    max-height: 100%;
    width: 100%;
    @media screen and (max-width: $md-max) , screen and (max-height: $md-height-max){
      height: auto;
      padding-top: 48px;
      padding-bottom: 48px;
      min-height: calc(100vh - 96px - 96px)
    }
  }

  .full-span-inner {
    position: relative;
    margin: auto;
    max-width: calc(100% * (5/8));
    overflow-x: hidden; //IE fix
    @media screen and (max-width: $sm-max) {
      max-width: calc(100% - 48px - 48px - 12px); // additional 12 overall added to make less cramped
    }
  }

</style>



// WEBPACK FOOTER //
// full_span_slide.vue?23f5ecb0